// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"546":"aa449c40","638":"34b8c5bf"}[chunkId] + ".chunk.js";
};